<script setup lang="ts">
import NumberInputField from '@/components/Fields/NumberInputField.vue'
import StackLayout from '@/components/Layouts/StackLayout.vue'
import type { RangeType } from '@/types/Range'

type Props = {
    value?: Partial<RangeType>
}
defineProps<Props>()
type Emits = {
    (e: 'change', value: Partial<RangeType>): void
}
defineEmits<Emits>()
</script>
<template>
    <StackLayout direction="row" :gap="8">
        <NumberInputField
            label="Min"
            :modelValue="value?.min"
            @change="$emit('change', { min: $event })" />
        <NumberInputField
            label="Max"
            :modelValue="value?.max"
            @change="$emit('change', { max: $event })" />
    </StackLayout>
</template>
